import { useEffect, useRef, useState, useImperativeHandle } from 'preact/hooks';
import SlickSlider from '../slickSlider';
import HorizontalScroll from '../horizontalScroll';
import { isMobile } from '../../../utils/helper';
import { useWindowDimension } from '../../../utils/useWindowDimension';
import { forwardRef } from 'preact/compat';

const CustomSlider = (props, ref) => {
  const {
    childWidth,
    children,
    mobileViewWithSlider,
    outerContainerClass,
    noOfSlides,
    customSettings,
  } = props;
  const [outerContainerWidth, setOuterContainerWidth] = useState(0);
  const [activeSlide, setActiveSlide] = useState(0);
  const outerContainer = useRef();
  const customSlider = useRef(null);
  const [dimension] = useWindowDimension();
  const [width] = dimension;
  useEffect(() => {
    setOuterContainerWidth(outerContainer.current.clientWidth);
  }, [width]);
  const sliderSettings = {
    dots: false,
    dotsClass: 'slick-dots slick-thumb',
    infinite: false,
    speed: 500,
    rows: 1,
    slidesToShow: childWidth
      ? outerContainerWidth / childWidth >= 1
        ? outerContainerWidth / childWidth
        : 1
      : 1,
    slidesToScroll: childWidth
      ? Math.floor(outerContainerWidth / childWidth) > 0
        ? Math.floor(outerContainerWidth / childWidth)
        : 1
      : 1,
    placeholders: false,
    mobileFirst: true,
    swipeToSlide: false,
    draggable: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    customPaging: () => <div className='primaryDots' />,
    beforeChange: (current, next) => setActiveSlide(next),
    ...customSettings,
  };
  useImperativeHandle(ref, () => ({
    nextSlide() {
      noOfSlides - activeSlide - Math.floor(outerContainerWidth / childWidth) >
        0 && customSlider.current.nextSlide();
    },
    prevSlide() {
      activeSlide > 0 && customSlider.current.prevSlide();
    },
  }));

  return (
    <div
      className={`customSlickTrack ${outerContainerClass}`}
      ref={outerContainer}>
      {isMobile && !mobileViewWithSlider ? (
        <HorizontalScroll>{children}</HorizontalScroll>
      ) : (
        <SlickSlider ref={customSlider} setting={sliderSettings}>
          {children}
        </SlickSlider>
      )}
    </div>
  );
};

export default forwardRef(CustomSlider);

function NextArrow(props) {
  const { className, propStyle, onClick } = props;
  const customeStyle = {
    display: className.includes('slick-disabled') ? 'none' : 'flex',
    position: 'absolute',
    right: '-50px',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    width: '50px',
    height: '50px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    cursor: 'pointer',
    background: '#FFFFFF',
    boxShadow: '0px 2px 16px -2px rgba(0, 0, 0, 0.12)',
    zIndex: 1,
  };
  return (
    <div style={{ ...customeStyle, ...propStyle }} onClick={onClick}>
      <span
        class={`material-icons cursorPointer`}
        style={{
          fontSize: '20px',
          color: 'rgba(0, 0, 0, 0.4)',
          fontWeight: '700',
        }}>
        navigate_next
      </span>
    </div>
  );
}

function PrevArrow(props) {
  const { className, propStyle, onClick } = props;
  const customeStyle = {
    display: className.includes('slick-disabled') ? 'none' : 'flex',
    position: 'absolute',
    left: '5px',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    width: '50px',
    height: '50px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    cursor: 'pointer',
    background: '#FFFFFF',
    boxShadow: '0px 2px 16px -2px rgba(0, 0, 0, 0.12)',
    zIndex: 1,
  };
  return (
    <div style={{ ...customeStyle, ...propStyle }} onClick={onClick}>
      <span
        class={`material-icons cursorPointer`}
        style={{
          fontSize: '20px',
          color: 'rgba(0, 0, 0, 0.4)',
          fontWeight: '700',
        }}>
        navigate_before
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./componentsBICRevamp/common/customSlider/index.js